import wells from "./wells";
import permits from "./permits";
import owners from "./owners";
import meters from "./meters";

export const CONFIG = {
  wells,
  permits,
  owners,
  meters,
};

export default CONFIG;
